<template>
    <div
        v-resize="onResize"
        class="ma-0 pa-0"
        :style="{ height: `${height}px` }"
    >
        <v-banner sticky class="ma-0 pa-0" color="white" single-line>
            <v-text-field
                class="mb-2"
                sticky
                v-model="search"
                dense
                filled
                @keydown.space="findTags"
                @input="findTags"
                @change="findTags"
                @keydown.enter="findTags"
                hide-details="auto"
                placeholder="Search"
                prepend-inner-icon="mdi-magnify"
                rounded
            />
        </v-banner>
        <v-row
            v-if="loadingBottom"
            class="mt-0"
            align="center"
            justify="center"
        >
            <v-progress-linear color="primary" indeterminate />
        </v-row>
        <v-row
            v-if="tool"
            id="scroll-target"
            class="overflow-y-auto mt-1"
            :style="{ height: `${height - 58}px` }"
            @scroll="onScroll"
        >
            <viewer
                v-if="firstLoaded"
                :images="filteredImages"
                @inited="inited"
                class="viewer"
                ref="viewer"
                rebuild
            >
                <img
                    class="image"
                    v-for="src in filteredImages"
                    :key="src.id"
                    :src="src.image320x320URL"
                    :alt="src.imageURL ? src.imageURL : src.image320x320URL"
                />
            </viewer>
            <v-col
                v-for="image in filteredImages"
                :key="image.id"
                :class="[image.show ? 'd-flex child-flex' : 'd-none']"
                cols="6"
                xs="6"
                sm="6"
                lg="3"
            >
                <ToolImageCard
                    :image="image"
                    :uid="image.id"
                    :totalImages="commercialImages.length"
                    :loading="loading"
                    :tags="tags"
                    @downloadFile="downloadFile"
                    @deleteImage="selectImageForDelete"
                    @updateImage="updateImage"
                    @removeTag="removeTag"
                    @editTags="editTags"
                    @show="show"
                    @loaded="handleLoaded"
                    @removeImage="removeImage"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import ToolImageCard from '@/components/Tools/ToolImageCard'
import { storage } from '@/services/firebase'
import API from '@/services/api'
import { mapActions, mapState, mapMutations } from 'vuex'

export default {
    name: 'CommercialImages',
    props: {
        tool: Object,
    },
    components: {
        ToolImageCard,
    },
    data() {
        return {
            folder: 'photo_galery',
            company: JSON.parse(localStorage.getItem('company')),
            loading: false,
            search: '',
            deleteError: false,
            error: false,
            errorMsg: null,
            imageToDelete: null,
            deleteDialog: false,
            editDialog: false,
            tag: '',
            imageToUpdate: {},
            height: 0,
            images: [],
            pagination: 1,
            folderImages: 'photo_galery',
            uploadedData: false,
            numberItems: 20,
            loadingBottom: false,
            firstLoaded: false,
            tags: [],
            loadedCount: 0,
        }
    },
    watch: {
        tool: async function() {
            await this.setShow()
        },
        filteredImages() {
            this.$nextTick(() => {
                if (this.$refs.viewer) this.$refs.viewer.$viewer.update()
            })
        },
    },
    async created() {
        if (this.tool) {
            await this.setShow()
        }
    },
    computed: {
        ...mapState(['commercialImages']),
        filteredImages() {
            const visibleImages = this.commercialImages.filter(img => img.show)
            const images = visibleImages.slice(
                0,
                this.pagination * 20 <= visibleImages.length
                    ? this.pagination * 20
                    : visibleImages.length
            )
            return images
        },
        totalImages() {
            return this.filteredImages.length
        },
    },
    async mounted() {
        try {
            this.loading = true
            this.tags = await API.getToolTags()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        ...mapActions([
            'addToolsAction',
            'setCommercialImagesAction',
            'addCommercialImageAction',
            'delCommercialImageAction',
            'resetComercialImagesAction',
        ]),
        ...mapMutations(['setErrorItems']),
        removeImage(image) {
            const index = this.commercialImages.find(i => i.id == image)
            if (index >= 0) {
                this.delCommercialImageAction(index)
            }
        },
        openDelete(image) {
            this.deleteDialog = true
            this.imageToDelete = image
        },
        inited(viewer) {
            this.$viewer = viewer
        },
        firstLoad() {
            this.firstLoaded = true
        },
        handleLoaded() {
            this.loadedCount++
            if (
                this.loadedCount === 20 ||
                this.loadedCount === this.totalImages
            ) {
                this.firstLoad()
            }
        },
        onScroll(e) {
            const target = e.target
            if (
                target.scrollTop + target.clientHeight >=
                target.scrollHeight - 50
            ) {
                if (!this.loadingBottom) {
                    this.loadingBottom = true
                    setTimeout(() => {
                        this.pagination++
                        this.loadingBottom = false
                    }, 500)
                }
            }
        },

        async setShow() {
            try {
                this.loadingBottom = true
                this.resetComercialImagesAction()
                const {
                    data: { commercialImages },
                } = await API.getCommercialImages()
                for (let index in commercialImages) {
                    commercialImages[index].show = true
                    this.addCommercialImageAction(commercialImages[index])
                }
                this.uploadedData = true
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loadingBottom = false
            }
        },
        findTags() {
            if (this.search) {
                const regex = new RegExp(this.search.toLowerCase(), 'gi')
                this.commercialImages.forEach(image => {
                    if (
                        image.projectName &&
                        image.projectName
                            .toLowerCase()
                            .includes(this.search.toLowerCase())
                    ) {
                        image.show = true
                        return null
                    }
                    const tags = image.tags.filter(tag => tag.match(regex))

                    if (tags.length > 0) {
                        image.show = true
                    } else {
                        image.show = false
                    }
                })
            } else {
                this.commercialImages.forEach(image => (image.show = true))
            }
        },
        downloadFile(image) {
            var xhr = new XMLHttpRequest()
            xhr.responseType = 'blob'
            xhr.onload = () => {
                var blob = xhr.response
                var fileUrl = URL.createObjectURL(blob)
                var fileLink = document.createElement('a')
                fileLink.href = fileUrl
                fileLink.setAttribute('download', image.file)
                document.body.appendChild(fileLink)
                fileLink.click()
            }
            xhr.open('GET', image.imageURL)
            xhr.send()
        },
        show(id) {
            const idx = this.filteredImages.findIndex(img => img.id === id)
            if (idx !== -1) {
                this.$viewer.index = idx
                this.$viewer.show()
            }
        },
        async deleteOnStorage(file) {
            const path = `${this.company}/${this.folder}`
            const storageRef = storage().ref(path)
            const refDoc = storageRef.child(file)
            await refDoc.delete()
            return true
        },
        async selectImageForDelete(image) {
            this.imageToDelete = image
            await this.deleteImage()
        },
        async deleteImage() {
            try {
                this.loading = true
                const index = this.commercialImages.indexOf(this.imageToDelete)
                if (index >= 0) {
                    await API.deleteCommercialImage(
                        this.commercialImages[index].id
                    )
                    await this.deleteOnStorage(this.imageToDelete.file)
                    await this.deleteOnStorage(this.imageToDelete.file320x320)
                    this.delCommercialImageAction(index)
                    this.deleteDialog = false
                } else {
                    this.imageToDelete = undefined
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        editTags(image) {
            this.imageToUpdate = image
            this.editDialog = true
        },
        async updateImage(id, image) {
            try {
                this.imageToUpdate = image
                this.loading = true
                this.error = false
                this.errorMsg = ''
                const idx = this.commercialImages.findIndex(
                    img => img.id === id
                )
                if (idx != -1) {
                    await API.updateCommercialImage(
                        this.commercialImages[idx].id,
                        {
                            ...(this.imageToUpdate.projectName != undefined
                                ? {
                                      projectName: this.imageToUpdate
                                          .projectName,
                                  }
                                : {}),
                            tags: this.imageToUpdate.tags,
                        }
                    )
                    this.setCommercialImagesAction({
                        idx,
                        image: this.imageToUpdate,
                    })
                    this.editDialog = false
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        addTag(event) {
            event.preventDefault()
            var val = event.target.value.trim().toLowerCase()
            if (val.length > 0) {
                this.imageToUpdate.tags.push(val)
                event.target.value = ''
                this.tag = ''
            }
        },
        removeTag(index) {
            this.imageToUpdate.tags.splice(index, 1)
        },
        removeLastTag(event) {
            if (event.target.value.length === 0) {
                this.removeTag(this.imageToUpdate.tags.length - 1)
            }
        },
        async loadImages(image) {
            const path = `${this.company}/${this.folderImages}`
            const storageRef = storage().ref(path)
            const profilePicRef = storageRef.child(image.file)
            const profilePic320x320Ref = storageRef.child(image.file320x320)
            await profilePicRef
                .getDownloadURL()
                .then(url => {
                    image.imageURL = url
                })
                .catch(error => {
                    if (error) image.imageURL = ''
                })
            await profilePic320x320Ref
                .getDownloadURL()
                .then(url => {
                    image.image320x320URL = url
                })
                .catch(error => {
                    if (error) image.image320x320URL = ''
                })
        },
        onResize() {
            this.height =
                window.innerHeight - this.$vuetify.application.top - 173
        },
    },
}
</script>
<style scoped>
.v-card {
    transition: opacity 0.4s ease-in-out;
}
.v-card:not(.on-hover) {
    opacity: 0.9;
}

.show-btns {
    color: #0277bd !important;
}
.image {
    display: none;
}
</style>
